import React from 'react'
import Router from '@/router/Router'
import './theme/lib/antd.less'
import './theme/styles/App.scss'

export default function App() {
    return <Router />
}
